class WorksSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const el = document.querySelector('.s-works__swiper-button-next-circle .circle');
    const speed = 5000;
    
    const swiper = new Swiper(".s-works__swiper", {
      slidesPerView: 1.05,
      spaceBetween: 24,
      speed: 500,
      loop: true,
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      
      on: {
        slideChangeTransitionStart: function () {
          el.style.transitionDuration = '0.5s',
          el.style.strokeDashoffset = '264px'
        },

        slideChangeTransitionEnd: function () {
          el.style.transitionDuration = speed + 'ms',
          el.style.strokeDashoffset = '0'
        },
      },
      
      breakpoints: {
        768: {
          spaceBetween: 50,
          slidesPerView: 2.2,
        },
      },

      scrollbar: {
        el: ".s-works__swiper-scrollbar",
        draggable: true 
      },
    
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".s-works__swiper-button-next",
        prevEl: ".s-works__swiper-button-prev",
        clickable: true,
      },
    });
  }
}
